module.exports = __webpack_public_path__ + "img/rotation-icon.351b55a7.svg";